module.exports = __webpack_public_path__ + "img/gzh.f6efd09d.jpg";